"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorContainer = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../../../Colors");
const option_1 = require("../../../../common/option");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const server_1 = require("../../../../server");
const DSTL001_Detail_Child_1 = require("../../../DST/DSTL001/component/DSTL001_Detail_Child");
const ErrorContainerStyled = styled_components_1.default.div `
	border-style: solid;
	border-color: var(--color-grey-w, #b6bac0);
	border-width: ${({ $isDesktop }) => (!$isDesktop ? '0' : ' 0px 0px 1px 0px;')};

	${({ $isMobile }) => $isMobile &&
    `
		width: 100%;
		height: 100%;
	`}

	.title {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);

		letter-spacing: var(--h4-letter-spacing, -0.02em);
		font-weight: var(--h4-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		${({ $isMobile, $isTablet }) => $isMobile
    ? `
		font-size: var(--h6-font-size, 14px);
		line-height: var(--h6-line-height, 18px);
		`
    : $isTablet
        ? `
			font-size: var(--h5-font-size, 16px);
			line-height: var(--h5-line-height, 24px);`
        : `

			font-size: var(--h4-font-size, 20px);
			line-height: var(--h4-line-height, 32px);
		`}
	}

	${({ $isDesktop }) => $isDesktop &&
    `
	.empty_data {
		flex: unset;
		height: 240px;
	}
	`}
`;
exports.ErrorContainer = react_1.default.memo(({ item, isTest, isSubmit, test_id, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [statisticItem, setStatisticItem] = react_1.default.useState(null);
    const { data: statisticData, refetch: statisticRefetch } = (0, server_1.useStatistics)({ test_id });
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    (0, react_1.useEffect)(() => {
        statisticRefetch();
    }, [test_id]);
    (0, react_1.useEffect)(() => {
        if (!statisticData)
            return;
        setStatisticItem(statisticData);
    }, [statisticData]);
    const renderContent = react_1.default.useMemo(() => {
        if (!item)
            return null;
        if (item.status === 'created' ||
            (item.status === 'open' && !isSubmit) ||
            !statisticItem?.hardest_rank ||
            statisticItem?.hardest_rank.length <= 0) {
            const title = item.status === 'created'
                ? t('assignment.notOpen', {
                    name: t(`assignment.${isTest ? 'test' : 'name'}`),
                })
                : item.status === 'open' && !isSubmit
                    ? t('assignment.notSubmit')
                    : item.status === 'open'
                        ? t('assignment.assignmentCheck', {
                            name: t(`assignment.${isTest ? 'test' : 'name'}`),
                        })
                        : t('assignment.noSubmitInfo');
            return (react_1.default.createElement(option_1.EmptyTable, { title: title, iconProps: {
                    icon: 'detail-delete',
                    size: isMobile ? 28 : 32,
                    fill: Colors_1.Colors.w_grey,
                } }));
        }
        else {
            return react_1.default.createElement(DSTL001_Detail_Child_1.ErrorRateTable, { hardest: statisticItem?.hardest_rank, showMore: true });
        }
    }, [item, isSubmit, statisticItem?.hardest_rank]);
    return (react_1.default.createElement(ErrorContainerStyled, { className: "wrong-rate-list", "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop },
        isDesktop && react_1.default.createElement("div", { className: "title" }, t('assignment.errorRates')),
        renderContent));
});
